import { useAtom } from 'jotai'

import { renderStatusStore } from 'src/stores/renderStatusStore'

export const useRenderStatusStore = () => {
  const [renderStatusStoreValue, setRenderStatusStoreValue] = useAtom(renderStatusStore.state)

  return {
    renderStatusStoreValue,
    setRenderStatusStoreValue,
  }
}
